export const optionsFromExpandableTable = (props) => {
  const {
    expandableTableData,
    changePageValues,
    setChangePageValues,
    selectedVal,
  } = props.dataObject;
  const { dynamicEntityDataMapping } = props.operation;
  if (dynamicEntityDataMapping && dynamicEntityDataMapping.mapping) {
    const tableData = expandableTableData[selectedVal];
    if (!tableData || typeof tableData !== 'object') {
      if (dynamicEntityDataMapping.onUndefined
        && typeof dynamicEntityDataMapping.onUndefined === 'object') {
        Object.entries(dynamicEntityDataMapping.onUndefined).forEach(([fieldId, fieldValue]) => {
          changePageValues[fieldId] = fieldValue;
        });
        setChangePageValues({ ...changePageValues });
      }
      return;
    }
    dynamicEntityDataMapping.mapping.forEach((mapping) => {
      const fromFieldIds = Array.isArray(mapping.fromFieldId)
        ? mapping.fromFieldId : [mapping.fromFieldId];
      // Clear toFieldId before mapping to prevent stale values from a previous selection
      // persisting when the new selection's tableData does not contain the fromFieldId key.
      changePageValues[mapping.toFieldId] = '';
      fromFieldIds.forEach((fromFieldId) => {
        if (fromFieldId in tableData) {
          changePageValues[mapping.toFieldId] = tableData[fromFieldId] || '';
        }
      });
    });
    setChangePageValues({ ...changePageValues });
  }
};
